import { FormControlLabel, Switch, Theme, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { useBottomControlsSectionCollapse } from "@rentablo/components";

const ShowHistoricContainer = styled.div`
  display: flex;
  align-self: center;
`;

type Props = {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ShowHistoric = ({ checked, onChange }: Props) => {
  const { t } = useTranslation();
  const isSM = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const collapseSection = useBottomControlsSectionCollapse();

  return (
    <ShowHistoricContainer>
      <FormControlLabel
        control={
          <Switch
            size={isSM ? "medium" : "small"}
            checked={checked}
            onChange={(event) => {
              onChange(event);
              collapseSection();
            }}
            name="show-historic-switch"
            color="primary"
          />
        }
        sx={{ margin: 0 }}
        label={t("components.depotsStatistic.showHistoricSwitch")}
      />
    </ShowHistoricContainer>
  );
};
